import { faCog, faDownToLine, faPencil } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, ColouredTile, IconWithMenu, Link, ListItem, StatusBadge, Text,
} from '@domain-group/suit-theme'

import useCampaignPortalSync from '@hooks/useCampaignPortalSync'

import { CampaignPortalSyncModel } from '@models/types'

const tileColor = {
  'export-false': 'red',
  'export-true': 'blue',
  'import-false': 'red',
  'import-true': 'lightGrey',
}

const CampaignPortalSyncListItem = (props: { campaignPortalSync: CampaignPortalSyncModel }) => {
  const { campaignPortalSync } = props

  const campaignPortalSyncPayload = useCampaignPortalSync(campaignPortalSync)
  const {
    callbacks: { viewPortalSyncDetails },
    campaignPortalSync: {
      file, identity_code, portal_id, success, sync_type, unique_id,
    },
    lastSyncDateStr,
    portal,
  } = campaignPortalSyncPayload

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        padding: 'large',
      }}
      disableHover
    >
      <ColouredTile
        boxProps={{ height: 20, width: 60 }}
        // @ts-expect-error TS7053
        color={tileColor[`${sync_type}-${success}`]}
      >
        {sync_type}
      </ColouredTile>

      <Box flexDirection="column" marginLeft="large">
        <Text fontSize="small">{portal.title || `Portal #${portal_id}`}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small" maxWidth={[150, 150, 150, 250]} variant="ellipsis">
          {identity_code} - {unique_id}
        </Text>
      </Box>

      <Box flexDirection="column" justifyContent="flex-end" marginLeft="auto" textAlign="right">
        <Text>
          <StatusBadge
            color={success ? 'green' : 'red'}
            text={success ? 'Success' : 'Failed'}
          />
        </Text>

        <Text
          color="bodyFontLightColor"
          display={['none', 'inline-block']}
          fontSize="xsmall"
          marginTop="small"
        >
          {lastSyncDateStr || 'Not Synced'}
        </Text>
      </Box>

      <IconWithMenu
        boxProps={{ marginLeft: 'large' }}
        icon={(
          <Link greyLink>
            <FontAwesomeIcon icon={faCog} />
          </Link>
      )}
        shouldUsePortal
      >
        {/*
         // @ts-expect-error TS2741 */}
        <IconWithMenu.Menu closeOnClick>
          {file && (
            <Link greyLink href={file} target="_blank">
              <FontAwesomeIcon icon={faDownToLine} /> Download File
            </Link>
          )}

          <Link greyLink onClick={() => viewPortalSyncDetails()}>
            <FontAwesomeIcon icon={faPencil} /> View Portal Sync
          </Link>
        </IconWithMenu.Menu>
      </IconWithMenu>
    </ListItem>
  )
}

export default CampaignPortalSyncListItem
